<div class="buttonGuide">
    <div class="navigationBlock">
        <a href="/guide" class="navigationLink">
            <p class="navigationText">ПОЛУЧИТЬ ОЗНАКОМИТЕЛЬНЫЕ ПУТЕВОДИТЕЛИ</p>
        </a>
    </div>
</div>

<style>
    .buttonGuide {
        margin: 0 auto;
        position: relative;
        /* height: 1200px; */
    }

    .navigationBlock {
        height: 60px;
        margin: 0 auto;
        /* background-color: black; */
    }

    .navigationLink {
        cursor: pointer; /*Курсор при наведении*/
        position: relative;
        text-decoration: none;
    }

    .navigationText:hover {
        filter: brightness(90%);
        box-shadow: rgb(38, 57, 77) 0px 30px 40px -10px;
    }

    .navigationText {
        display: flex; /* Добавляем flexbox */
        flex-direction: column; /* Выравниваем по вертикали */
        justify-content: center; /* Центрируем по вертикали */
        align-items: center; /* Центрируем по горизонтали (если нужно) */
        height: 60px;
        background: linear-gradient(to top, #4f7942, #addfad);
        /* background-color: #4f7942; */
        border-radius: 10px;
        color: #eaf4e5;
        box-shadow: rgb(38, 57, 77) 0px 20px 30px -10px;
    }

    @media (min-width: 1280px) {
        .buttonGuide {
            width: 50%;
            margin-top: 20px;
            margin-bottom: 50px;
        }
        .navigationBlock {
            width: 50%;
        }
    }
    @media (max-width: 480px) {
        .buttonGuide {
            width: 90%;
            margin-bottom: 20px;
        }
        .navigationBlock {
            width: 100%;
        }
        .navigationText {
            font-size: 12px;
            font-weight: 600;
        }
    }
    @media (min-width: 481px) and (max-width: 833px) {
        .buttonGuide {
            width: 90%;
            margin-bottom: 20px;
        }
        .navigationBlock {
            width: 100%;
        }
        .navigationText {
            font-size: 13px;
            font-weight: 600;
        }
    }
    @media (min-width: 834px) and (max-width: 1023px) {
        .buttonGuide {
            width: 90%;
            margin-bottom: 20px;
        }
        .navigationBlock {
            width: 100%;
        }
        .navigationText {
            font-size: 17px;
            font-weight: 600;
        }
    }
    @media (min-width: 1024px) and (max-width: 1279px) {
        .buttonGuide {
            width: 90%;
            margin-bottom: 20px;
        }
        .navigationBlock {
            width: 100%;
        }
        .navigationText {
            font-size: 23px;
            font-weight: 600;
        }
    }
</style>
